import React from 'react';

import { EstimationsBodySubForm } from '@vlabs/pages/handlers/forms';
import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import i18next from 'i18next';

import st from './shared.module.sass';

function StepBodyEstimations() {
  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {i18next.t('handlers:какие атрибуты тела необходимо определять?')}
        </StepTitle>
      )}
    >
      <EstimationsBodySubForm />
    </Step>
  );
}

StepBodyEstimations.fieldNames = [
  'estimate',
  'extract',
];

export { StepBodyEstimations };
